import { format, getMonth, getYear } from "date-fns";
import { round } from "lodash";
import compact from "lodash/compact";

export const joinClasses = (classNames) => {
  if (!Array.isArray(classNames)) {
    return "";
  }
  return compact(classNames).join(" ");
};

export function extractErrorMsg(error) {
  // Sometimes error messages are in object or string
  // This will extract the message in both case
  if (typeof error === "object") {
    return error.message;
  } else if (typeof error === "string") {
    return error;
  } else {
    return "Something went wrong.";
  }
}

export const asyncForEach = async (array, callback) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};

export const anonArray = (length) => Array.from(Array(parseInt(length)).keys());

export const dateRangeDisplayer = (start, end) => {
  if (getYear(start) !== getYear(end)) {
    return `${format(start, "PP")} - ${format(end, "PP")}`;
  } else if (getMonth(start) !== getMonth(end)) {
    return `${format(start, "MMM d")} - ${format(end, "MMM d")}, ${format(
      end,
      "yyyy"
    )}`;
  } else {
    return `${format(start, "MMMM")} ${format(start, "d")} - ${format(
      end,
      "d"
    )}, ${format(end, "yyyy")}`;
  }
};

export const hexToRgb = (hex) => {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : {
        r: 255,
        g: 255,
        b: 255,
      };
};

export function createMarkup(markup) {
  return { __html: markup };
}

export const isIframed = window.location !== window.parent.location;

export const amountToString = (
  amount,
  decimalPlaces = 2,
  withCurrency = true
) => {
  if (typeof amount === "string") {
    const parsedAmt = isNaN(parseFloat(amount)) ? 0 : parseFloat(amount);
    amount = parsedAmt;
  }
  const decimalAmount = round(amount, decimalPlaces);
  return [withCurrency && "$", decimalAmount.toFixed(decimalPlaces)].join("");
};

export const roundToNearestHundred = (num = 1) => {
  if (typeof num === "string") {
    const number = parseFloat(num) <= 100 ? 100 : parseFloat(num);
    return Math.round(number / 100) * 100;
  } else if (typeof num !== "number") {
    return 100;
  } else {
    return Math.round(num / 100) * 100;
  }
};
